/**
 * The Key Hunt window is drawn at WINDOW_SCALE of its 1080x1920 Figma frame, centred, so
 * the "prize claimed" ribbon (full screen width) sticks out past the window's edges with
 * its curled ends visible. The popups (prize choice, safe) keep the full frame scale.
 */
export const KEY_HUNT_WINDOW_SCALE = 0.92;

const K = KEY_HUNT_WINDOW_SCALE;

/** Title box on the ribbon (frame px, centre 544,196); long titles shrink to the width. */
export const KEY_HUNT_TITLE_BOX = { x: 174, y: 121, w: 740, h: 150, font_size: 100 };

/** English "Key Hunt" is short and looked tiny at the common cap. */
export const KEY_HUNT_TITLE_EN_FONT_SCALE = 1.05;

/** Same API as LayoutScaler, positions are frame coordinates scaled about the frame centre. */
export const KeyHuntLayout = {
  xFromDesign: ( x: number ): number => LayoutScaler.xFromDesign( 540 + ( x - 540 ) * K ),
  yFromDesign: ( y: number ): number => LayoutScaler.yFromDesign( 960 + ( y - 960 ) * K ),
  widthFromDesign: ( w: number ): number => LayoutScaler.widthFromDesign( w * K ),
  heightFromDesign: ( h: number ): number => LayoutScaler.heightFromDesign( h * K ),
  textSizeFromDesign: ( s: number ): number => LayoutScaler.textSizeFromDesign( s * K ),
  textBorderSizeFromDesign: ( s: number ): number => LayoutScaler.textBorderSizeFromDesign( s * K ),
  cornerRadiusFromDesign: ( r: number ): number => LayoutScaler.cornerRadiusFromDesign( r * K ),
};

/** For elements laid out relative to their own parent (task rows): scale only, no centring. */
export const KeyHuntLocalLayout = {
  ...KeyHuntLayout,
  xFromDesign: ( x: number ): number => LayoutScaler.xFromDesign( x * K ),
  yFromDesign: ( y: number ): number => LayoutScaler.yFromDesign( y * K ),
};
